<app-link [url]="'https://t.me/' + value" displayText="">
  <app-icon [src]="'assets/images/icons-svg/telegram-icon.svg'" [size]="'18px'"></app-icon>
</app-link>
